// @flow
// ----------------------------------------------------------------------
// <copyright file='Izenda.FilterDescription.js' company='Izenda'>
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import action from './Izenda.FilterDescriptionAction';
import { compact, isEmpty } from 'lodash/fp';

const FilterDescription = (props: {}) => {
  const { field, position, operatorSource, filterSource } = props;
  const source = compact(operatorSource);
  const filterDescription = field.getFilterInfoDisplayName(position, isEmpty(source) ? compact(filterSource) : source);

  return (
    !isEmpty(filterDescription) && (
      <p style={field.fieldDetails.getDisplayStyle()}>{filterDescription}</p>
    )
  );
};

FilterDescription.propTypes = {
  field: PropTypes.object.isRequired,
  position: PropTypes.number
};

FilterDescription.displayName = 'FilterDescription';

export default action(FilterDescription);



// WEBPACK FOOTER //
// ./ui/modules/Reports/ReportViewer/Izenda.FilterDescription.js